import React from 'react';

export default
    <g id="icon/pause/white" stroke="none" strokeWidth="1" fillRule="evenodd">
        <path d="M3,35.6835789 L13.1055789,35.6835789 L13.1055789,0.315473684 L3,0.315473684 L3,35.6835789 Z M23.2102105,0.315473684 L23.2102105,35.6835789 L33.3157895,35.6835789 L33.3157895,0.315473684 L23.2102105,0.315473684 Z" id="Path_411" ></path>
    </g>
